module.exports = __webpack_public_path__ + "27a45acd924e757089ea5d43d5105cba.jpg";